export enum Page {
    POLL = 'poll',
    FORM = 'form',
    RESULT = 'result'
}